import { jsx as e } from "react/jsx-runtime";
import { useMemo as o, useEffect as l } from "react";
import { debounce as a } from "lodash";
import { FormField as r } from "../FormField.js";
import { BaseInput as t } from "../BaseStyledComponents/BaseInput.js";
import { NumericFormatCustom as n } from "./NumericFormatCustom.js";
const i = ({ control: i2, name: m, label: c, inputRef: d, onFocus: s, onChange: u, onBlur: p, placeholder: f = "Введіть значення", required: b = false, preview: g = false, disabled: v, unit: x, min: F, max: h, decimalScale: B, value: C, loading: D = false, tooltip: j, sx: R, debounced: S = false, debounceMs: q = 300, useCommaDecimal: w = false }) => {
  const P = (e2) => {
    let o2 = e2.target.value || null;
    o2 && w && (o2 = o2.replace(".", ",")), i2.setFieldValue(m, o2);
  }, V = o(() => a(P, q), [i2, m, q]);
  l(() => () => V.cancel(), [V]);
  const $ = (e2) => {
    e2.preventDefault();
    const o2 = e2.clipboardData.getData("text"), l2 = w ? o2.replace(/\./g, ",") : o2.replace(/,/g, ".");
    i2.setFieldValue(m, l2);
  };
  return e(r, { control: i2, name: m, label: x && g ? `${c} (${x})` : c, required: b, preview: g, disabled: v, value: C, loading: D, sx: R, tooltip: j, fieldRef: d, children: ({ name: o2, value: l2, onBlur: a2, fieldRef: r2 }) => e(t, { name: o2, value: l2 ?? "", onChange: u || (S ? V : P), onFocus: s, onBlur: (e2) => {
    a2(e2), p == null ? void 0 : p(e2);
  }, onPaste: $, placeholder: f, disabled: v, slotProps: { input: { ref: r2, component: n, decimalScale: B, min: F, max: h } }, endDecorator: x }) });
};
export {
  i as InputNumericField
};
//# sourceMappingURL=InputNumericField.js.map
